export function formatCurrency(value: number): string {
  if (value >= 1000000) {
    return `$${(value / 1000000).toFixed(1)}M`
  }
  if (value >= 1000) {
    return `$${(value / 1000).toFixed(0)}K`
  }
  return `$${value.toFixed(0)}`
}

export function formatPercent(value: number): string {
  return `${value.toFixed(1)}%`
}

export function formatMinutes(value: number): string {
  const hours = Math.floor(value / 60)
  const mins = value % 60
  if (hours === 0) return `${mins}m`
  return `${hours}h ${mins}m`
}

export type PerformanceColor = 'green' | 'yellow' | 'red'

export function getPerformanceColor(
  metric: string,
  value: number,
): PerformanceColor {
  switch (metric) {
    case 'five9CallsPerDay':
      return value >= 25 ? 'green' : value >= 15 ? 'yellow' : 'red'
    case 'ringCentralCallsPerDay':
      return value >= 18 ? 'green' : value >= 12 ? 'yellow' : 'red'
    case 'totalCallsPerDay':
      return value >= 40 ? 'green' : value >= 30 ? 'yellow' : 'red'
    case 'five9TalkTime':
      return value >= 120 ? 'green' : value >= 60 ? 'yellow' : 'red'
    case 'ringCentralTalkTime':
      return value >= 80 ? 'green' : value >= 45 ? 'yellow' : 'red'
    case 'totalTalkTime':
      return value >= 180 ? 'green' : value >= 120 ? 'yellow' : 'red'
    case 'conversations':
      return value >= 25 ? 'green' : value >= 15 ? 'yellow' : 'red'
    case 'pullToAppPct':
      return value >= 60 ? 'green' : value >= 40 ? 'yellow' : 'red'
    case 'appToSubmissionPct':
      return value >= 80 ? 'green' : value >= 60 ? 'yellow' : 'red'
    case 'submissionToLockPct':
      return value >= 70 ? 'green' : value >= 50 ? 'yellow' : 'red'
    case 'submissionToSignedPct':
      return value >= 90 ? 'green' : value >= 75 ? 'yellow' : 'red'
    case 'signedToFundPct':
      return value >= 95 ? 'green' : value >= 85 ? 'yellow' : 'red'
    case 'falloutPct':
      return value <= 10 ? 'green' : value <= 20 ? 'yellow' : 'red'
    case 'followUpCompliancePct':
      return value >= 90 ? 'green' : value >= 75 ? 'yellow' : 'red'
    case 'suspendedFilePct':
      return value <= 5 ? 'green' : value <= 15 ? 'yellow' : 'red'
    default:
      return 'green'
  }
}

export function getTrendColor(trend: 'up' | 'down', metric: string): string {
  const invertedMetrics = [
    'falloutPct',
    'suspendedFilePct',
    'teamFalloutPct',
    'activeCoachingFlags',
  ]
  const isInverted = invertedMetrics.includes(metric)

  if (trend === 'up') {
    return isInverted ? 'text-red-500' : 'text-green-500'
  } else {
    return isInverted ? 'text-green-500' : 'text-red-500'
  }
}
